import { NavigationExtras, Params } from '@angular/router';
import { SafariObjectId } from '../base-object/models/app/safari-object-base';

export interface IRouterState {
  routerNavigationInfo: RouterNavigationInfo;
}

export class RouterNavigationInfo {
  // Both forms accept SafariObjectId so callers can drop entity ids straight in without
  // String() coercion. Angular's Router.navigate (array form) takes any[]; navigateByUrl
  // (single form) needs a string — the router effect coerces SafariObjectId to string before
  // calling navigateByUrl.
  path: SafariObjectId[] | SafariObjectId;
  /**
   * If set to true the editor guard will make sure that the page is not dirty before it navigates.
   * Default is false since the majority of these calls come from response to successful saves.
   */
  checkDirty?: boolean;
  /**
   * In general if a navigation request is issued while another one is pending the new one will take precedence.
   * However in case of saves we want to override that. Saves will sometimes be called as a response to "Save changes"
   * upon clicking on a link. If we used the defatul logic what would happen is that the original navigate (the one user wanted)
   * would be overriden by the page's default save that was called after save change dialog. So we should pass true here when calling
   * from save actions.
   */
  ignoreIfNavigationPending?: boolean;
  extras?: NavigationExtras;
  additionalInfo?: any;
}
export class RouterRouteChangeInfo {
  params: Params;
  path: string;
}
export interface IRouterFeatureState {
  routerState: IRouterState;
}
